/*
 * Returns undefined until logic to determine a specific blueprint is necessary
 */
export const getBlueprintVersion = (): string | undefined => {
  return undefined;
};
